import * as api from "services/api";
import { getErrors } from "helpers/error";
import ls from "Localization";
import _ from "lodash";
import { Callback } from "Types/Callback";

export const GET_MARKETINGS = "[MARKETING] GET_MARKETINGS";
export const GET_MARKETINGS_SUCCESS = "[MARKETING] GET_MARKETINGS_SUCCESS";
export const GET_MARKETINGS_FAILED = "[MARKETING] GET_MARKETINGS_FAILED";

export const GET_MARKETING = "[MARKETING] GET_MARKETING";
export const GET_MARKETING_SUCCESS = "[MARKETING] GET_MARKETING_SUCCESS";
export const GET_MARKETING_FAILED = "[MARKETING] GET_MARKETING_FAILED";

export const CREATE_MARKETING = "[MARKETING] CREATE_MARKETING";
export const CREATE_MARKETING_SUCCESS = "[MARKETING] CREATE_MARKETING_SUCCESS";
export const CREATE_MARKETING_FAILED = "[MARKETING] CREATE_MARKETING_FAILED";

export const UPDATE_MARKETING = "[MARKETING] UPDATE_MARKETING";
export const UPDATE_MARKETING_SUCCESS = "[MARKETING] UPDATE_MARKETING_SUCCESS";
export const UPDATE_MARKETING_FAILED = "[MARKETING] UPDATE_MARKETING_FAILED";

export const RESEND_MARKETING = "[MARKETING] RESEND_MARKETING";
export const RESEND_MARKETING_SUCCESS = "[MARKETING] RESEND_MARKETING_SUCCESS";
export const RESEND_MARKETING_FAILED = "[MARKETING] RESEND_MARKETING_FAILED";

export const IMPORT_USERS = "[MARKETING] IMPORT_USERS";
export const IMPORT_USERS_SUCCESS = "[MARKETING] IMPORT_USERS_SUCCESS";
export const IMPORT_USERS_FAILED = "[MARKETING] IMPORT_USERS_FAILED";

export const SET_VALUE = "[MARKETING] SET_VALUE";
export const CLEAR_VALUES = "[MARKETING] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues(payload: boolean = false) {
	return { type: CLEAR_VALUES, payload };
}

export function getMarketings(
	skip?: number,
	take: number = 10,
	filter?: any,
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<any[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MARKETINGS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Marketing?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: { getAll: false } }));
				} else {
					dispatch({
						type: GET_MARKETINGS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}
				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MARKETINGS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_MARKETINGS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getMarketing(id: any, callback?: Callback<any>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MARKETING });

		try {
			const { login } = getState();

			const response = await api.sendGet(`/Marketing/${id}`, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_MARKETING_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MARKETING_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_MARKETING_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function createMarketing(file: any, callback: any) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_MARKETING });

		try {
			const { login, marketing } = getState();

			const {
				name,
				users,
				startAt,
				economicMode,
				emailSubject,
				emailMessage,
				smsMessage,
				whatsAppMessage,
				whatsAppRestrict,
				pushMessage,
				pushTitle,
				pushAction,
				pushValue
			} = marketing;

			const errors: any = {};

			if (!name) errors.name = ls.required;
			if (!users.length) errors.users = ls.required;

			if (emailMessage && !emailSubject) {
				errors.emailSubject = ls.required;
			}

			if (pushMessage && !pushTitle) {
				errors.pushTitle = ls.required;
			}

			if (
				!emailMessage &&
				!smsMessage &&
				!whatsAppMessage &&
				!file &&
				!pushMessage
			) {
				errors.emailMessage =
					"Precisa preenchar pelo menos um campo de mensagem";
				errors.smsMessage = "Precisa preenchar pelo menos um campo de mensagem";
				errors.whatsAppMessage =
					"Precisa preenchar pelo menos um campo de mensagem";
				errors.pushMessage =
					"Precisa preenchar pelo menos um campo de mensagem";
			}

			if (_.keys(errors).length > 0) {
				return dispatch({
					type: CREATE_MARKETING_FAILED,
					payload: errors
				});
			}

			const model = {
				name,
				users: users.map((c: any) => ({ ...c, user: c.user?._id })),
				startAt,
				economicMode,
				emailSubject,
				emailMessage,
				smsMessage,
				whatsAppMessage,
				whatsAppFile: "",
				whatsAppRestrict,
				pushTitle,
				pushMessage,
				pushAction,
				pushValue
			};

			if (file) {
				const response = await api.sendPostFile("/Api/Marketing/Upload", file, {
					Authorization: `Bearer ${login.token}`
				});

				const result = await response.json();

				if (!result.isValid) {
					const errors = getErrors(result.errors);

					dispatch({
						type: CREATE_MARKETING_FAILED,
						payload: errors
					});

					callback && callback(errors);

					return;
				}

				model.whatsAppFile = result.model;
			}

			const response = await api.sendPost("/marketing", model, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: CREATE_MARKETING_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_MARKETING_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: CREATE_MARKETING_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function editMarketing(file: any, callback?: Callback<any>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: UPDATE_MARKETING });

		try {
			const { login, marketing } = getState();

			const {
				item,
				name,
				users,
				startAt,
				economicMode,
				emailSubject,
				emailMessage,
				smsMessage,
				whatsAppMessage,
				whatsAppRestrict,
				pushMessage,
				pushTitle,
				pushAction,
				pushValue
			} = marketing;

			const errors: any = {};

			if (!name) errors.name = ls.required;
			if (!users.length) errors.users = ls.required;

			if (emailMessage && !emailSubject) {
				errors.emailSubject = ls.required;
			}

			if (pushMessage && !pushTitle) {
				errors.pushTitle = ls.required;
			}

			if (
				!emailMessage &&
				!smsMessage &&
				!whatsAppMessage &&
				!file &&
				!pushMessage
			) {
				errors.emailMessage =
					"Precisa preenchar pelo menos um campo de mensagem";
				errors.smsMessage = "Precisa preenchar pelo menos um campo de mensagem";
				errors.whatsAppMessage =
					"Precisa preenchar pelo menos um campo de mensagem";
				errors.pushMessage =
					"Precisa preenchar pelo menos um campo de mensagem";
			}

			if (_.keys(errors).length > 0) {
				return dispatch({
					type: UPDATE_MARKETING_FAILED,
					payload: errors
				});
			}

			const model = {
				...item,
				name,
				users: users.map((c: any) => ({ ...c, user: c.user?._id })),
				startAt,
				economicMode,
				emailSubject,
				emailMessage,
				smsMessage,
				whatsAppMessage,
				whatsAppFile: "",
				whatsAppRestrict,
				pushTitle,
				pushMessage,
				pushAction,
				pushValue
			};

			if (file) {
				const response = await api.sendPostFile("/Marketing/Upload", file, {
					Authorization: `Bearer ${login.token}`
				});

				const result = await response.json();

				if (!result.isValid) {
					const errors = getErrors(result.errors);

					dispatch({
						type: CREATE_MARKETING_FAILED,
						payload: errors
					});

					callback && callback(errors);

					return;
				}

				model.whatsAppFile = result.model;
			}

			const response = await api.sendPut("/marketing/" + item.id, model, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: UPDATE_MARKETING_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_MARKETING_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: UPDATE_MARKETING_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function resendMarketing(id: any, callback?: Callback<any>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: UPDATE_MARKETING });

		try {
			const { login } = getState();

			const response = await api.sendPut("/marketing/" + id + "/Resend", null, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: UPDATE_MARKETING_SUCCESS
				});

				callback && callback(null);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_MARKETING_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: UPDATE_MARKETING_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function importUsers(users: any[], callback?: Callback<any>, progressCallback?: (progress: any) => void) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: IMPORT_USERS });

		try {
			const { login } = getState();

			// Optimize chunk size for bulk operations - increased from 100 to 500
			// This reduces the number of API calls while maintaining reasonable payload size
			const chunks = _.chunk(users, 500);

			let response: Response | any = null;
			const allProcessedUsers: any[] = [];
			const allErrors: any[] = [];

			// Process each chunk sequentially
			for (let i = 0; i < chunks.length; i++) {
				const chunk = chunks[i];
				
				// Update progress before processing chunk
				if (progressCallback) {
					progressCallback({
						currentChunk: i + 1,
						totalChunks: chunks.length,
						processedUsers: allProcessedUsers.length,
						totalUsers: users.length
					});
				}
				
				try {
					response = await api.sendPost("/marketing/import-users", { users: chunk }, {
						Authorization: `Bearer ${login.token}`
					});

					const result = await response.json();

					if (result.isValid) {
						// Accumulate processed users from this chunk
						if (result.model && result.model.processedUsers) {
							allProcessedUsers.push(...result.model.processedUsers);
						}
					} else {
						const errors = getErrors(result.errors);
						allErrors.push(...errors);
					}
				} catch (chunkError) {
					allErrors.push({
						chunk: i + 1,
						error: "Connection error for chunk"
					});
				}
			}

			// Dispatch success with all processed users
			dispatch({
				type: IMPORT_USERS_SUCCESS,
				payload: {
					processedUsers: allProcessedUsers,
					totalProcessed: allProcessedUsers.length,
					totalChunks: chunks.length,
					errors: allErrors
				}
			});

			callback && callback(null, {
				processedUsers: allProcessedUsers,
				totalProcessed: allProcessedUsers.length,
				totalChunks: chunks.length,
				errors: allErrors
			});
		} catch (error) {
			return dispatch({
				type: IMPORT_USERS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
